import React, { Component } from 'react'

function Donate(props) {
  if (window.donations_enabled) {
    return <DonateView />;
  } else {
    return <h3 className="feed-notice">Donations are not enabled for this event</h3>;
  }
}

const DonateView = React.createClass({
  shouldComponentUpdate: function() {
    return false;
  },
  componentDidMount: function() {
    // Add the script after render to activate the widget
    const script = document.createElement("script");
    script.src = `https://${pledgeling.domain_guest}/assets/javascripts/widget-loader.js`;
    script.id = "pledgeling-widget-js"
    script.async = true;
    document.body.appendChild(script);
  },
  componentWillUnmount: function() {
    // Remove the script when unmounting to keep things clean
    const script = document.getElementById("pledgeling-widget-js");
    if (script) {
      script.parentElement.removeChild(script);
    }
  },
  render: function() {
    const eventId = window.evite_event.id;
    const { pledgeling, user_id } = window;
    const itemId = eventId ? eventId : pledgeling.anon_id;
    return (
      <div
        className="plg-widget simple-shadowbox"
        data-skin="evite_tipping"
        data-type="donate-anonymous"
        data-partner-key={pledgeling.partner_key}
        data-btn-border-color="#2c0476"
        data-item-id={itemId}
        data-x-user-id={user_id}
      >
        <span className="pledgeling-step-loader"></span>
      </div>
    )
  }
})

export default Donate;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/donate/components.es6